import React, { useState } from 'react';

import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import Select, { MultiValue } from 'react-select';

import { Company, SelectOpt } from '@/types';
import { selectCustomStyle } from '@/config/model';

import { useCreateAIModule } from '../api';
import { AIModulePayload, emptyAI } from '../types';

type RBModalProps = {
  show: boolean;
  handleClose: () => void;
  activeCompanies: Company[];
};

/**
 * == New AI Module create Modal ==
 * @returns
 */
export const AddAIModule = ({
  show,
  handleClose,
  activeCompanies,
}: RBModalProps) => {
  // == form upload payload ==
  const [payload, setPayload] = useState<AIModulePayload>(emptyAI);

  const createQuery = useCreateAIModule({
    onSuccess: () => handleClose(),
  });

  const { isLoading } = createQuery;

  const companyToSelectOpt = (c: Company) => ({
    label: c.name,
    value: c.id as number,
  });
  const companyOptions = activeCompanies.map(companyToSelectOpt);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setPayload((prevPayload) => ({ ...prevPayload, [name]: value }));
  };

  const handlSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    setPayload((prevPayload) => ({ ...prevPayload, [name]: value }));
  };

  const handleCompanySelect = (values: MultiValue<SelectOpt>) => {
    // const companies = values.map((o) => o);
    setPayload({ ...payload, companies: [...values] });
  };

  const handleSubmitToAddNewAIModule = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    await createQuery.mutateAsync({ payload });
  };

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title className="h6">Add New AI Module</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={handleSubmitToAddNewAIModule}>
        <Modal.Body>
          <Row className="mb-2">
            {/* == Label field == */}
            <Form.Group as={Col}>
              <Form.Label>Label</Form.Label>
              <Form.Control
                name="label"
                value={payload.label}
                placeholder="AI module label in front-end"
                onChange={handleInputChange}
              />
            </Form.Group>
            {/* == Module Type field == */}
            <Form.Group as={Col}>
              <Form.Label>Back Module Key</Form.Label>
              <Form.Control
                name="moduleType"
                value={payload.moduleType}
                placeholder="AI module type in back-end"
                onChange={handleInputChange}
              />
            </Form.Group>
          </Row>
          {/* == companies selection == */}
          <Form.Group className="mb-2">
            <Form.Label>Companies using it</Form.Label>
            <Select
              isMulti
              placeholder="Select a company..."
              name="companies"
              options={companyOptions}
              classNamePrefix="select"
              styles={selectCustomStyle}
              onChange={handleCompanySelect}
            />
          </Form.Group>
          {/* == Module is default field | status == */}
          <Row className="mb-2">
            {/* left - isDefault */}
            <Form.Group as={Col}>
              <Form.Label>Is Default</Form.Label>
              <Form.Select
                aria-label="is default module or not"
                name="isDefault"
                value={payload.isDefault}
                onChange={handlSelectChange}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Form.Select>
            </Form.Group>
            {/* right - status */}
            <Form.Group as={Col}>
              <Form.Label>Status</Form.Label>
              <Form.Select
                aria-label="active or not"
                name="status"
                value={payload.status}
                onChange={handlSelectChange}
              >
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
              </Form.Select>
            </Form.Group>
          </Row>
          {/* == Module Description field == */}
          <Form.Group className="mb-2">
            <Form.Label>Description</Form.Label>
            <Form.Control
              name="description"
              value={payload.description}
              placeholder="AI module description(optional)"
              onChange={handleInputChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button type="submit" variant="primary">
            {isLoading && (
              <>
                <Spinner size="sm" animation="border" />
                ......
              </>
            )}
            {!isLoading && `Save`}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
